let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lod7c")).then(() => parcelRequire('gn2YK'));